<template>
  <div>
    <MobialisFormWithValidation @onValidate="submit">
      <mobialis-text-input-with-validation
        :rules="{ required: true, regex: /^([^0-9]*)$/ }"
        :label="$t('message.common.firstName')"
        v-model="firstName"
        vid="firstName"
        data-cy="firstName"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        :rules="{ required: true, regex: /^([^0-9]*)$/ }"
        :label="$t('message.common.lastName')"
        v-model="lastName"
        vid="lastName"
        data-cy="lastName"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        rules="required|length:10"
        :label="$t('message.common.phoneNumber')"
        v-model="phoneNumber"
        vid="phoneNumber"
        placeholder="(   )"
        mask-type="phoneNumber"
        type="tel"
        data-cy="phoneNumber"
        class="p-number"
        :error-message="avErrors['phoneNumber']"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        rules="required|email"
        :label="$t('message.common.emailAddress')"
        v-model="emailAddress"
        vid="emailAddress"
        data-cy="emailAddress"
        type="email"
        :error-message="avErrors['emailAddress']"
      ></mobialis-text-input-with-validation>
      <div v-if="!isFromHomeRoute">
        <mobialis-text-input-with-validation
          v-if="countryCode === 'US'"
          rules="required|length:5|numeric"
          :label="$t('message.common.zipCode')"
          v-model="postalCode"
          vid="zipCode"
          data-cy="zipCode"
          class="input-width-100"
          mask-type="zipCode"
        ></mobialis-text-input-with-validation>
        <mobialis-text-input-with-validation
          v-else
          rules="required|length:6"
          :label="$t('message.common.postalCode')"
          v-model="postalCode"
          vid="postalCode"
          mask-type="postalCode"
          data-cy="postalCode"
          class="input-width-100"
        ></mobialis-text-input-with-validation>
      </div>
      <div class="check">
        <mobialis-check-box-with-validation
          rules="required:true"
          :label="termsText"
          vid="tandc"
          id="tandc"
          data-cy="tAndC"
          v-model="tandc"
        >
        </mobialis-check-box-with-validation>
      </div>
      <mobialis-button type="submit" class="mt-5" data-cy="submit">{{ $t('message.common.continue') }}</mobialis-button>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';
import { avErrorMixin } from '@/mixins';

export default {
  name: 'PersonalInformationForm',
  data() {
    return {
      tandc: false,
    };
  },
  mixins: [avErrorMixin],
  methods: {
    async submit(isValid) {
      if (!isValid) {
        return;
      }

      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createLead');
        try {
          await this.$store.dispatch('lead/updateLead');
          if (this.isFromHomeRoute) {
            this.$router.push({
              name: `drive-home-address-${this.baseRoute}`,
            });
          } else {
            this.$router.push({
              name: `drive-anything-else-${this.baseRoute}`,
            });
          }
        } catch (err) {
          log('Error in test drive personal form - Update Lead', err);
          this.$router.push({ name: `drive-error-${this.baseRoute}` });
        }
      } catch (err) {
        if (!this.handleServerSideError(err)) {
          log('Error in test drive personal form  - Create Lead', err);
          this.$router.push({ name: `drive-error-${this.baseRoute}` });
        }
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
  computed: {
    ...mapGetters('testDrive', ['isFromHomeRoute']),
    termsText() {
      return this.$t('message.testDrive.formCheckBox', { link: this.termsLink, dealer: this.getBusinessName });
    },
    termsLink() {
      return this.$t('message.testDrive.formLink');
    },
    countryCode() {
      return this.$store.getters['business/getBusinessCountry'];
    },
    firstName: {
      get() {
        return this.$store.state.user.firstName;
      },
      set(value) {
        this.$store.commit('user/SET_FIRST_NAME', value);
      },
    },
    lastName: {
      get() {
        return this.$store.state.user.lastName;
      },
      set(value) {
        this.$store.commit('user/SET_LAST_NAME', value);
      },
    },
    emailAddress: {
      get() {
        return this.$store.state.user.emailAddress;
      },
      set(value) {
        this.$store.commit('user/SET_EMAIL_ADDRESS', value);
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.user.phoneNumber;
      },
      set(value) {
        this.$store.commit('user/SET_PHONE_NUMBER', value);
      },
    },
    postalCode: {
      get() {
        return this.$store.state.user.postalCode;
      },
      set(value) {
        this.$store.commit('user/SET_POSTAL_CODE', value);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.p-number {
  width: 407px;
  max-width: 100%;
}
</style>
